<template>
    <div style="background: #f9f9f9; padding-bottom: 80px" class="adaptiveMobileNewClass">
        <!-- <div class="soluBanner">
          <img src="../../assets/3D/newBanner.png" alt="" />
          <div class="soluBanBox">
            <h2>新闻中心</h2>
            <div class="soluBanText">
              <p>汇聚行业最新资讯</p>
              <p>RICH INDUSTRY SOLUTIONS AND CASES COVER ALL FIELDS</p>
            </div>
          </div>
        </div> -->
        <div class="new_top_nap" >
         <!-- @click="getNewsItem"  当前位置： <span>新闻中心 </span><span v-if="titleName" style="cursor: pointer;">> {{ titleName }} </span>
            <span v-if="titleName_1" style="cursor: pointer;"> > {{ titleName_1 }}</span> -->
			<span>当前位置：</span>
			<el-breadcrumb separator=">">
			  <el-breadcrumb-item :to="{ path: '/news' }" @click="getNewsItem">新闻中心</el-breadcrumb-item>
			  <el-breadcrumb-item v-if="titleName">{{titleName}}</el-breadcrumb-item>
			  <el-breadcrumb-item  v-if="titleName_1">{{titleName_1}}</el-breadcrumb-item>
			</el-breadcrumb>
        </div>
        <div class="new_con"  v-loading="loading">
            <h2>
                {{ newDetail.title }}
            </h2>
            <div class="flex new_con_box">
                <div class="new_con_left flex">
                    <p v-if="newDetail.source != null && newDetail.source!=''">来源：{{ newDetail.source }}</p>
                    <p>发布时间：{{ newDetail.createDate }}</p>
                    <!--          <p>09:42</p>-->
                    <p>
                        <i class="iconfont">&#xe611;</i>
                        <span> {{ newDetail.pageViews }} </span>
                    </p>
                </div>
                <div class="new_con_right flex">
                    <p class="flex">
                        <i v-if=newDetail.isCollection class="el-icon-star-on"
                           style="margin-right: 8px;color: #E6A23C;cursor: pointer;font-size: 24px;"
                           @click="deleteCollectionNews"></i>
                        <i v-if=!newDetail.isCollection class="el-icon-star-off"
                           style="margin-right: 8px;cursor: pointer;font-size: 22px;" @click="collectionNews"></i>
                        <span> {{ newDetail.collectionsNum }}</span>
                    </p>
                    <i class="new_icon"></i>

                    <p class="flex">
                        <i v-if=newDetail.isLike class="iconfont"
                           style="margin-right: 8px;color: #E6A23C;cursor: pointer;" @click="deleteNewsFabulous">&#xe665;</i>
                        <i v-if=!newDetail.isLike class="iconfont" style="margin-right: 8px;cursor: pointer;"
                           @click="saveNewsFabulous">&#xe665;</i>
                        <!-- <i class="iconfont">&#xe665;</i>-->
                        <span> {{ newDetail.likesNum }} </span>
                    </p>
                    <i class="new_icon"></i>

                    <p class="flex">

                        <!--   <el-popover
                                   placement="bottom"
                                   width="200"
                                   v-model="visible"
                                   trigger="click">
                             <div class="qrcode" ref="qrCodeUrl"  style="width: 200px;height: 200px"></div>
                             <i class="iconfont el-dropdown-link" slot="reference" >&#xe6d1;</i>
                           </el-popover>
                           <span> {{ newDetail.forwardNum }} </span>-->
                        <share :config="config" style="z-index: 99999999;"></share>
                    </p>
                </div>
            </div>


            <div class="new_con_mess editorStyleDetailContent ql-editor vHtmlMess" v-html="newDetail.content"></div>
            <!--<p>
              为共同推进增材制造医疗器械行业法规标准的规范化发展，通过有关专家与起草单位的共同调研、资料收集、会议研讨等工作，根据《中国医疗器械行业协会团体标准管
              理办法》，
              增材制造医疗器械专业委员会团体标准化技术委员会，现阶段组织编写完
              成了十五项标准草案(附件 1-15)，现正式向社会公开征求意见，为期 30 天。
            </p>
            <p>
              如各相关单位有任何意见或建议，请填写《反馈意见表》(附件)并以电子邮件形式将修改意见或建议反馈至增材制造医疗器械标委会。意见反馈时间截止至
              2021 年 7 月 10 日。
            </p>
            <div class="new_img">
              <img src="../../assets/redT.jpeg" alt="" />
            </div>-->
            <div class="flex new_bottom">
                <div class="new_bottom_left" @click="beforeDetail">
                    <p class="flex"><i></i> 上一篇</p>
                    <p v-if="before != null">{{ before.title }}</p>
                </div>
                <div class="new_bottom_right" @click="afterDetail">
                    <p>下一篇</p>
                    <p v-if="after != null">{{ after.title }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import QRCode from 'qrcodejs2';
    import {
        getNewcurrent,
        getNewDetail,
        saveNewsCollection,
        deleteNewsCollection,
        saveNewsFabulous,
        deleteNewsFabulous,
        getProgramChildList
    } from "../../utils/interface";

    export default {
        //   新闻
        name: "news",
        metaInfo () {
            return {
                title: this.metaTitle,
                meta: [{                 // set meta
                    name: "keywords",
                    content: this.metaKeywords,
                },
                    {                 // set meta
                        name: "description",
                        content: this.metaDescription,
                    }
                ],
            }
        },
        components: {},
        data() {
            return {
                loading: false,
                config: {
                    url: window.location.href,
                    disabled: ['douban', 'linkedin', 'diandian', 'qq', 'qzone', 'tencent', 'google', 'twitter', 'tencent', 'weibo']
                },
                uuid: "",
                newDetail: "",
                before: {
                    uuid: "",
                },
                after: {
                    uuid: "",
                },
                showERCode: false,
                titleName: "",
                titleName_1: "",
                programUuid: null,
                setIn: null, // 定时器
                userDetail: {},
                metaTitle:'',
                metaKeywords:'',
                metaDescription:'',
            };
        },
        created() {
            this.backTop();
            this.uuid = this.$route.params.uuid;
            this.programUuid = this.$route.query.programUuid;
            this.titleName = "";
            this.titleName_1 = "";
            this.getNewcurrent();
            this.setIn = setInterval(() => {
                if (this.isTokenDoor === true) {
                    clearInterval(this.setIn);
                    this.getNewsDetail();
                }
            }, 500);
        },
        computed: {
            ...mapState({
                isTokenDoor: "isTokenDoor",
            }),
        },
        mounted() {
            this.creatQrCode();
        },
        destroyed() {
        },
        methods: {
            backTop() {
                let timer = setInterval(function () {
                    var top = document.body.scrollTop || document.documentElement.scrollTop;
                    var speed = top / 4;
                    if (document.body.scrollTop != 0) {
                        document.body.scrollTop -= speed;
                    } else {
                        document.documentElement.scrollTop -= speed;
                    }
                    if (top == 0) {
                        clearInterval(timer);
                    }
                }, 30);
            },

            creatQrCode() {
                var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                    text: window.location.href, // 需要转换为二维码的内容
                    width: 200,
                    height: 200,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.H
                })
            },

            forwardNews() {
                if (this.showERCode) {
                    this.showERCode = false;
                } else if (!this.showERCode) {
                    this.showERCode = true;
                }
            },

            getNewcurrent() {
                if (!this.$store.state.isLogin) {
                    return;
                }
                getNewcurrent().then((res) => {
                    this.userDetail = res;
                })
            },


            collectionNews() {
                if (!this.$store.state.isLogin) {
                   this.$message.success("您需要先登陆哦！")
                   this.$router.push("/login");
                }
                let param = {
                    newsUuid: this.newDetail.uuid,
                    userId: this.userDetail.uuid,
                }
                saveNewsCollection(param).then((response) => {
                    this.getNewsDetail();
                })
            },
            deleteCollectionNews() {
                if (!this.$store.state.isLogin) {
                    this.$message.success("您需要先登陆哦！")
                    // return false;
					this.$router.push("/login");
                }
                let param = {
                    newsUuid: this.newDetail.uuid,
                    userId: this.userDetail.uuid,
                }
                deleteNewsCollection(param).then((response) => {
                    this.getNewsDetail();
                })
            },

            saveNewsFabulous() {
                if (!this.$store.state.isLogin) {
                    this.$message.success("您需要先登陆哦！")
                    // return false;
					this.$router.push("/login");
                }
                let param = {
                    newsUuid: this.newDetail.uuid,
                    userId: this.userDetail.uuid,
                }
                saveNewsFabulous(param).then((response) => {
                    this.getNewsDetail();
                })
            },
            deleteNewsFabulous() {
                if (!this.$store.state.isLogin) {
                   this.$message.success("您需要先登陆哦！")
				   this.$router.push("/login");
                    // return false;
                }
                let param = {
                    newsUuid: this.newDetail.uuid,
                    userId: this.userDetail.uuid,
                }
                deleteNewsFabulous(param).then((response) => {
                    this.getNewsDetail();
                })
            },

            getNewsDetail() {
                let param = {};
                param.uuid = this.uuid;
                param.programUuid = this.programUuid;
                if (this.$store.state.isLogin) {
                    param.userId = this.userDetail.uuid;
                }
                this.loading = true
                getNewDetail(param).then((res) => {
                    this.loading = false
                    if (res.success) {
                        this.metaTitle = res.data.current.title+"-增材云— 创意出发，打印无限可能！/  增材云— 增材制造领域首个综合性工业互联网平台！";
                        this.metaKeywords = res.data.current.metaKeywords;
                        this.metaDescription = res.data.current.metaDescription;

                        this.newDetail = res.data.current;
                        this.before = res.data.before;
                        this.after = res.data.after;
                        this.config.title = res.data.current.title;
                        this.config.description = res.data.current.summary;
                        this.config.image = res.data.current.pictureUrl;
                        let param = {
                            uuid: res.data.current.programUuid,
                        }
                        var reg_exp = new RegExp("video-js", "g"); 
                        this.newDetail.content = this.newDetail.content.replace(reg_exp, "");

                        getProgramChildList(param).then((response) => {
                            if (response.length > 0) {
                                this.titleName = response[0].parentName;
                                this.titleName_1 = response[0].label;
                            } else {
                                this.titleName = response[0].programName;
                            }
                        })
                    }
                }).catch(()=>{
                    this.loading = false
                })
            },
            beforeDetail() {
                if (this.before != null) {
                    this.backTop();
                    this.uuid = this.before.uuid;
                    this.getNewsDetail();
                }
            },
            afterDetail() {
                if (this.after != null) {
                    // this.$router.push({
                    //   name: "newDetails",
                    //   params: {
                    //     uuid: this.after.uuid,
                    //     programUuid:  this.programUuid,
                    //     titleName: this.titleName,
                    //     titleName_1: this.titleName_1,
                    //   },
                    // });
                    this.backTop();
                    this.uuid = this.after.uuid;
                    this.getNewsDetail();
                }
            },
            getNewsItem() {
                this.$router.push({
                    name: "news",
                    params: {
                        programUuid: this.programUuid,
                    },
                });
            },
        },
    };
</script>

<style scoped lang="less">
    @import "../../assets/dist/css/share.min.css";

    .blue {
        color: #1181ff;
    }

    .red {
        color: #d60000;
    }

    .soluBanner {
        position: relative;
        width: 100%;

        img {
            width: 100%;
            display: block;
        }

        .soluBanBox {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 1200px;
            transform: translate(-50%, -50%);
            color: #fff;

            h2 {
                font-size: 38px;
                letter-spacing: 10px;
            }

            .soluBanText {
                // margin: 8px 0 60px;
                p:nth-child(1) {
                    font-size: 17px;
                }

                p:nth-child(2) {
                    font-size: 9px;
                }
            }
        }
    }

    .new_top_nap {
        font-size: 14px;
        color: #808080;
        width: 1200px;
        margin: 0 auto;
        padding: 20px 0;
		display: flex;
		align-items: center;

        span {
            color: #808080;
        }
    }

    .new_con {
        width: 1200px;
        margin: 0 auto;
        margin-bottom: 80px;
        background: #fff;

        h2 {
            color: #082a48;
            //border-bottom: 1px solid #efefef;
            text-align: center;
            padding: 15px 0;
        }

        .new_con_box {
            font-size: 13px;
            border-bottom: 1px solid #efefef;
            color: #bbb;
            justify-content: space-between;
            margin: 10px 0;
            padding: 0 40px;

            .new_con_left {
                margin-top: 7px;
                margin-bottom: 10px;

                p {
                    margin-right: 25px;
                }

                p:nth-last-child(1) {
                    align-items: center;

                    i {
                        margin-right: 5px;
                    }
                }
            }

            .new_con_right {
                align-items: center;
                margin-bottom: 10px;

                p {
                    align-items: center;

                    i {
                        margin-right: 5px;
                    }
                }

                .new_icon {
                    width: 1px;
                    height: 10px;
                    background: #efefef;
                    margin: 0 15px;
                }
            }
        }

        .new_con_mess {
            margin: 35px 0 20px;
            border-bottom: 1px solid #efefef;
            padding: 0 40px;
            padding-bottom: 20px;
            white-space: pre-wrap;
            p {
                margin-bottom: 20px;
                // text-indent: 2em;
                font-size: 15px;
                line-height: 30px;
                // color: #777;
            }
            /deep/img {
                max-width: 100% !important;
            }

            // .new_img {
            //     text-align: center;

            //     img {
            //         width: 50%;
            //     }
            // }

            /deep/ span {
                font-size: 15px;
                line-height: 30px;
                // color: #777 ;
            }
        }

        .new_bottom {
            position: relative;
            align-content: center;
            font-size: 14px;
            justify-content: space-between;
            padding: 0 40px;
            padding-bottom: 20px;
            height: 40px;
            cursor: pointer;

            .new_bottom_left {
                color: #082a48;

                p:nth-child(1) {
                    align-items: center;

                    i {
                        width: 5px;
                        height: 15px;
                        border-radius: 5px;
                        background: #082a48;
                        margin-right: 6px;
                        display: inline-block;
                    }
                }

                p:nth-child(2) {
                    padding-left: 11px;
                    margin-top: 4px;
                    width: 88%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }

            .new_bottom_right {
                color: #082a48;
                text-align: right;

                p:nth-child(1) {
                }

                p:nth-child(2) {
                    padding-left: 11px;
                    margin-top: 4px;
                    text-align: right;
                    position: absolute;
                    right: 0;
                    width: 30%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }
    }
	.editorStyleDetailContent{
		/deep/ .video-wrap{
			video{
				width: 100%;
			}
		}

	}
</style>



// WEBPACK FOOTER //
// src/components/news/newDetails.vue